export default "__VITE_ASSET__$4iTddDs__"